import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { uniq } from 'lodash';

const CATEGORIES = {
    HPP: '3fc29317-396e-4393-a980-761f3a9f7725',
    'Zkrácený úvazek/brigáda (DPP/DPČ)': '06f5de60-fe58-48e7-8a6d-ea73a3fe7c8c',
    Stáž: 'c13a21c8-9ff8-483e-ac31-acda0ac80c3a',
    'Bakalářské a diplomové práce': '97d3830e-1ebc-48af-ac7e-d1a94eb6b03a',
    'Trainee program': '79cb2a80-42c2-4a95-86f8-5e7a00034398'
};

const CATEGORY_INCLUSIVE = '15508ff2-9e91-436c-9475-40b052c01b21';
const CATEGORY_EXPATS = '826da718-61cb-4351-9d2c-aa6bfa0aa4f2';

const CATEGORIES_MAIN = {
    'Edu zóna pro NNO': '9b35dd5c-9dfb-41d9-9eb1-24379c95e7ad',
    'Edu zóna pro školy': 'b34d00ce-9cd8-49cc-8767-488d1585e9c9',
    'Partnerská zóna': 'b0f57942-a9a1-4d14-b164-44adccdc8da4'
};

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    function getLogo() {
        const str = row['Logo'].trim();

        if (!str) {
            return undefined;
        }

        const imageId = str
            .replace('https://drive.google.com/open?id=', '')
            .replace('&usp=drive_copy', '')
            .trim();
        // const match = regex.exec(row['Logo']);
        const imageUrl = 'https://drive.google.com/uc?id=' + imageId;

        return imageUrl;
    }

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['Titulek'],
            header: {
                title: row['Titulek'],
                text: row['Popisek'],
                imageUrl: getLogo()
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    const categories: string[] = row['Filtr - Typ smlouvy']
        .split(',')
        .map((e) => e.trim())
        .filter(Boolean)
        .map((e) => CATEGORIES[e])
        .filter(Boolean);

    if (row['Filtr - Hiring Expats'].trim().toLowerCase() === 'ano') {
        categories.push(CATEGORY_EXPATS);
    }

    if (row['Filtr - Inkluzivní zaměstnavatel'].trim().toLowerCase() === 'ano') {
        categories.push(CATEGORY_INCLUSIVE);
    }

    const extraCategory = CATEGORIES_MAIN[row['Název stage']];
    if (extraCategory) {
        categories.push(extraCategory);
    }

    mutationPayload.addToCategoriesId = uniq(categories);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row['Titulek']?.toLowerCase();
}

export const osuImportMethods = { duplicateChecker, parser };
